import teamSetupPickerStore from "../store/store";
import { mutatorAction } from "satcheljs";

export default mutatorAction('SET_TEAM_SETUP_SCHEDULING_GROUP_NAME', function setTeamSetupSchedulingGroupName(schedulingGroupName: string) {
    if (teamSetupPickerStore.teamSetupInfo) {
        teamSetupPickerStore.teamSetupInfo.schedulingGroupName = schedulingGroupName;
    }
});
